import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";

/** Project-to-project "depends on" edges (2026-09-14). Visual only:
 *  chips on the board, arrows on the exec Gantt. One flat list —
 *  consumers join to projects client-side. */
export interface ProjectDependency {
  id: number;
  blocker_project_id: string;
  blocked_project_id: string;
}

const KEY = ["project-deps"] as const;

export function useProjectDependencies() {
  return useQuery<ProjectDependency[]>({
    queryKey: KEY,
    queryFn: () => api.get("/project-dependencies/").then((r) => r.data),
    staleTime: 30_000,
  });
}

/** Writes go through the PRE-EXISTING blockers endpoints, so every
 *  surface edits the one table. */
export function useAddProjectDependency() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (edge: { blocker_project_id: string; blocked_project_id: string }) =>
      api
        .post(`/portfolio/${encodeURIComponent(edge.blocked_project_id)}/blockers`, {
          blocker_project_id: edge.blocker_project_id,
        })
        .then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEY });
    },
  });
}

export function useDeleteProjectDependency() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (edge: { blocker_project_id: string; blocked_project_id: string }) =>
      api.delete(
        `/portfolio/${encodeURIComponent(edge.blocked_project_id)}/blockers/${encodeURIComponent(edge.blocker_project_id)}`,
      ),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEY });
    },
  });
}
